//React
import { FunctionComponent } from "react";

//App Hooks
import {
	useAppDispatch,
	useAppSelector,
} from "../../../system/redux/hooks/redux-store-hooks";

//Selectors
import { selectCurrentSort } from "../../redux/selectors/sorting/select-current-sort";

//Util
import { isStringEmpty } from "drh-js-library/dist/drh-string-utils/is-string-empty";

//Components
import { SortOptions } from "../../models/sorting/sort-options";

interface LinkProps {}

const SortLink: FunctionComponent<LinkProps> = (props) => {
	const dispatch = useAppDispatch();

	//State Values
	const currentSort = useAppSelector(selectCurrentSort);

	const labelNoSortChosen = "Sort By";

	const getFacetLinkCssClass = function () {
		var className = "community-set__sort-by_text";

		if (isStringEmpty(currentSort)) {
			return className;
		}

		className += " " + currentSort;

		return className;
	};

	const getFacetLinkText = function () {
		if (isStringEmpty(currentSort)) {
			return labelNoSortChosen;
		}

		var sortOption = SortOptions[currentSort];

		if (sortOption === undefined) {
			return labelNoSortChosen;
		}

		return sortOption.Label;
	};

	return <span className={getFacetLinkCssClass()}>{getFacetLinkText()}</span>;
};

export default SortLink;
